import { ProductCard as AutopartsProductCard } from "@qubit/autoparts";
import type { ComponentProps, ReactNode } from "react";

import { useGetMultiTempGridInfo } from "~/hooks/useGetMultiTempGridInfo";
import { parseProductTempZone } from "~/lib/tempZone";

import { TemperatureZoneRibbon } from "./TemperatureZoneRibbon";

export type ProductCardRootProps = ComponentProps<
  typeof AutopartsProductCard.Root
> & {
  tempZone?: string | null;
};

/**
 * Re-exports autoparts `ProductCard` with a Qubit-specific `Root` wrapper.
 *
 * This wrapper exists so that each consumer of ProductCard doesn't need to call
 * the `useGetMultiTempGridInfo` hook and manage passing the ribbon prop.
 */
function ProductCardRootWithSideRibbon({
  tempZone,
  ...rest
}: ProductCardRootProps) {
  const { isMultiTempGrid } = useGetMultiTempGridInfo();
  const parsedTempZone = parseProductTempZone(tempZone);

  let sideRibbon: ReactNode | undefined;
  if (isMultiTempGrid && parsedTempZone !== null) {
    sideRibbon = <TemperatureZoneRibbon tempZone={parsedTempZone} />;
  }

  return <AutopartsProductCard.Root {...rest} sideRibbon={sideRibbon} />;
}

// The rest of ProductCard remains in autoparts but is re-exported here for convenience.
export const ProductCard = {
  ...AutopartsProductCard,
  Root: ProductCardRootWithSideRibbon
};
